"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var c_function_types_1 = require("./c-function-types");
exports.buildSimpleApi = c_function_types_1.buildSimpleApi;
var helpers_1 = require("./helpers");
exports.getInterfaceName = helpers_1.getInterfaceName;
exports.getInterfaceVersion = helpers_1.getInterfaceVersion;
